import { useState, useEffect } from "react";
import { Button } from "@mui/material";
import { initializeApp } from "firebase/app";
import { useTranslation } from "react-i18next";
import fetchWrapper from "utils/fetchWrapper";
import { RESOURCES_KEYS } from "utils/i18n/resources";
import { getMessaging, getToken } from "firebase/messaging";
import { getCurrentLanguage } from "utils/i18n/i18nManager";
import { useRedirectIfUnauthenticated } from "utils/azureAD/useRedirectIfUnauthenticated";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_APIKEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAINY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECTID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGINGSENDERID,
  appId: process.env.REACT_APP_FIREBASE_APIID,
};

var app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

interface NotificationToken {
  token: string;
  language: string;
}

export const Notifications = () => {
  const { t: translate } = useTranslation();
  const [token, setToken] = useState("");
  const { accounts } = useRedirectIfUnauthenticated();
  const [activateNotification, setActivateNotification] = useState(false);

  useEffect(() => {
    if (navigator.onLine && process.env.REACT_APP_NOTIFICATION_FEATURE_ENABLED === "true" && "Notification" in window) {
      Notification.requestPermission()
        .then((permission) => {
          if (permission === "granted" && token === "") {
            getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_VAPIDKEY })
              .then(async (currentToken) => {
                if (currentToken) {
                  console.log("current token for client: ", currentToken);
                  const url = `${process.env.REACT_APP_BACK_END_API}/technical/tokens/${accounts[0]?.username}`;
                  const notif: NotificationToken = {
                    token: currentToken,
                    language: getCurrentLanguage(),
                  };

                  await fetchWrapper.post(url, notif);
                  setToken(currentToken);
                } else {
                  console.log("No registration token available. Request permission to generate one.");
                }
              })
              .catch((err) => {
                console.log("An error occurred while retrieving token. ", err);
              });
          }
        })
        .catch((err) => console.log(err));
    }
  }, [accounts, activateNotification, token]);

  if (process.env.REACT_APP_NOTIFICATION_FEATURE_ENABLED === "true" && Notification.permission !== "granted") {
    return (
      <Button variant="contained" color="error" onClick={() => setActivateNotification(!activateNotification)}>
        {translate(RESOURCES_KEYS.NOTIFICATION_ACTIVATE)}
      </Button>
    );
  } else {
    return <></>;
  }
};
